module.exports = __webpack_public_path__ + "media/hevc-cm-example.d03a429a.mp4";